import { Injectable, signal, effect } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private readonly STORAGE_KEY = 'opscribe_sidebar_collapsed';

    isSidebarCollapsed = signal(this.getInitialState());

    constructor() {
        effect(() => {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.isSidebarCollapsed()));
        });
    }

    toggleSidebar() {
        this.isSidebarCollapsed.update(state => !state);
    }

    private getInitialState(): boolean {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        return stored ? JSON.parse(stored) : false;
    }
}
